import React from "react";
import { Link } from "react-router-dom";
import "../styles/card.css";

const Card = ({ card }) => {
  return (
    <div className="card-container" style={{ 
      backgroundImage: `url(${card.imgSrc})`, 
      backgroundSize: 'cover', 
      backgroundPosition: 'center',
      height: '400px',
      display: 'flex',
      alignItems: 'flex-end',
      justifyContent: 'center',
      position: 'relative',
      borderRadius: '15px',
    }}>
      <div className="card-overlay"></div>
      <div className="card-content">
        <h4>
          <Link to={card.link} className="card-link">
            {card.title}
          </Link>
        </h4>
        <p className="card-description">{card.description}</p>
        <Link to={card.link} className="card-read-more">
          Leia mais <i className="fa-solid fa-arrow-right"></i>
        </Link>
      </div>
      
    </div>
  );
};

export default Card;
